import { Grid } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useApi } from "@dzambalaorg/provider-api";
import { ListAction, StyledListWrapper } from "@framework/styled";

import { CreateFeatureFlag } from "./create";
import { EditableRow } from "./editable-row";

export const FeatureFlagsSettings = () => {
  const [open, setOpen] = useState<boolean>(false);
  const api = useApi();

  const {
    data: settings,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [],
    queryFn: (): Promise<Record<string, any>> => {
      return api.fetchJson({
        url: `/settings`,
      });
    },
  });

  const settingsRow = Object.entries(settings || {});

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "featureFlags"]} />

      <PageHeader message="pages.featureFlags.title">
        <ListAction
          onClick={() => setOpen(prev => !prev)}
          message="form.buttons.add"
          dataTestId="SettingAddButton"
          icon={AddCircle}
        />
      </PageHeader>

      <CreateFeatureFlag open={open} refetch={refetch} />

      <ProgressOverlay isLoading={isLoading}>
        {settings && settingsRow.length && (
          <StyledListWrapper count={settingsRow.length} isLoading={isLoading}>
            {settingsRow.map(([key, value]) => (
              <EditableRow key={key} row={{ key, value }} refetch={refetch} />
            ))}
          </StyledListWrapper>
        )}
      </ProgressOverlay>
    </Grid>
  );
};
